export enum LISLabOrderSendModes {
    Accepted = 1,
    Ordered = 2,
}